import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import { IncidentContext } from './ReportIncident'

const Step5 = () => {
  const { formValues, setFormValues, setTab } = useContext(IncidentContext)
  const [equipmentInvolved, setEquipmentInvolved] = useState(
    formValues?.equipmentInvolvedBoolean ?? ''
  )
  const [assetID, setAssetID] = useState(formValues?.assetID ?? '')
  const handleNext = (e) => {
    e.preventDefault()
    setFormValues((prev) => ({
      ...prev,
      assetID,
      equipmentInvolvedBoolean: equipmentInvolved,
    }))
    setTab((prev) => prev + 1)
    window.scrollTo(0, 0)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={3}
      component="form"
      onSubmit={handleNext}
    >
      <Typography variant="title2" fontSize="1rem">
        Equipment
      </Typography>
      <FormControl>
        <InputLabel id="equipmentInvolved-label">
          Was any equipment involved in the Incident?
        </InputLabel>
        <Select
          labelId="equipnentInvolved-label"
          id="equipmentInvolved"
          value={equipmentInvolved}
          label="Was any other person involved in the Incident?"
          onChange={(event) => setEquipmentInvolved(event.target.value)}
          required
        >
          <MenuItem value="No">No</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
        </Select>
      </FormControl>
      {equipmentInvolved === 'Yes' && (
        <TextField
          label="Asset ID"
          value={assetID}
          onChange={(e) => setAssetID(e.target.value)}
          required
          autoComplete="off"
        />
      )}
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setTab((prev) => prev - 1)}
        >
          Previous
        </Button>
        <Button variant="contained" color="primary" type="submit">
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default Step5
